import React from 'react';

import './Spinner.css';

export const Spinner = () => (
    <span className="loader"></span>
)